import type { FC } from 'react';
import { Box, LinearProgress } from '@mui/material';
import Logo from './Logo';

const LOGO_WIDTH = 200;
const PROGRESS_WIDTH = 160;

const SplashScreen: FC = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000,
      gap: 3,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxWidth: LOGO_WIDTH,
        minHeight: 80,
        '& img': {
          width: '100%',
          maxWidth: LOGO_WIDTH,
          height: 'auto',
          maxHeight: 100,
          objectFit: 'contain',
        },
      }}
    >
      <Logo width={LOGO_WIDTH} />
    </Box>

    <Box sx={{ width: '100%', maxWidth: PROGRESS_WIDTH }}>
      <LinearProgress
        sx={{
          height: 4,
          borderRadius: 2,
          backgroundColor: 'grey.200',
          '& .MuiLinearProgress-bar': {
            borderRadius: 2,
          },
        }}
      />
    </Box>
  </Box>
);

export default SplashScreen;
